import { proxy, useSnapshot } from 'valtio';

type PostLoginRedirect = {
  page: 'notifications' | 'profile';
};
type AuthState = {
  postLoginRedirect: PostLoginRedirect | null;
  loginRequested: boolean;
  isAuthenticating: boolean;
  logoutRequested: boolean;
  isLoggingOut: boolean;
};

export const authState: AuthState = proxy({
  postLoginRedirect: null,
  loginRequested: false,
  isAuthenticating: false,
  logoutRequested: false,
  isLoggingOut: false,
});

export const useAuthState = () => {
  const state = useSnapshot(authState);
  return state;
};

export const triggerLogin = () => {
  authState.postLoginRedirect = null;
  authState.loginRequested = true;
};
export const triggerLoginWithRedirect = ({
  postLoginRedirect,
}: {
  postLoginRedirect: PostLoginRedirect;
}) => {
  authState.postLoginRedirect = postLoginRedirect;
  authState.loginRequested = true;
};

export const triggerLogout = () => {
  authState.postLoginRedirect = null;
  authState.logoutRequested = true;
};
